<template>
  <v-container
    :key="locale"
    fluid
    class="top-image"
    style="height: 100vh; width: 100%; background-color: #1A454A;"
  >
    <!-- DESKTOP -->
    <v-card
      class="d-none d-lg-block"
      variant="text"
      style="top: 40%;"
    >
      <v-card-text>
        <v-img
          style="margin: auto; display: block;"
          src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
          lazy-src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
          width="50%"
        />
      </v-card-text>
      <v-card-text class="text-center text-h6 font-weight-bold text-white">
        <v-row justify="center" class="ma-0 pa-0">
          <v-col cols="12">
            <span style="font-family: Montserrat">{{ $t('intro.p1') }}</span>
          </v-col>
          <v-col cols="12">
            <span style="font-family: Montserrat">{{ $t('intro.p2') }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- MOBILE -->
    <v-card
      class="d-lg-none"
      variant="text"
      style="top: 20%;"
    >
      <v-card-text>
        <v-img
          style="margin: auto; display: block;"
          src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
          lazy-src="@/assets/logos/logo_final_whitetext_Prancheta 1.svg"
        />
      </v-card-text>
      <v-card-text class="text-center text-h6 font-weight-bold text-white">
        <v-row justify="center" class="ma-0 pa-0">
          <v-col cols="12">
            <span style="font-family: Montserrat">{{ $t('intro.p1') }}</span>
          </v-col>
          <v-col cols="12">
            <span style="font-family: Montserrat">{{ $t('intro.p2') }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { locale } = useI18n({ useScope: 'global' })
</script>

<style scoped>
.top-image {
  background: url('../assets/covers/topo.svg') no-repeat;
  background-size: 100%;
  margin-top: -9%;
}
</style>
